<mat-dialog-actions>
  <button class="btn close" type="button" mat-dialog-close></button>
</mat-dialog-actions>
  <div class="list-container">
    <div class="scrollbar-custom">
    <mat-expansion-panel [expanded]="true" *ngFor="let item of data">
      <mat-expansion-panel-header *ngIf="item.content.length">
        <mat-panel-title>
          <h2>{{ item.title | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row detail" *ngFor="let cont of item.content">
        <div class="col-md-3 detail-label">{{cont.key}}</div>
        <div class="col-md-9">
          <p *ngFor="let val of cont.value" class="detail-value">{{val}}</p>
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</div>
